module.exports = "<a data-link-info=\"{%- targetKey %}\" class=\"qllc-link filter-link {%- optional.uniqueClass %} {% if (optional.active === true) { %} active {% } %}\" href={%- linkHref %}>{%- text %}</a>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/modifiedLinkTemplates/linkTemplate.html
// module id = 1155
// module chunks = 1